<template>
  <div>
    <b-row>
      <b-col
        v-for="(file, key) in files"
        :class="classFile + ` my-1 `"
        :key="key"
        draggable="true"
        class="item"
      >
        <File
          :file="file"
          :name="file.name"
          :showCheckbox="showCheckbox"
          :keyService="keyService"
          :keyValue="keyValue"
          :hasEditTypeAttachment="hasEditTypeAttachment"
          @removeFile="removeFile"
          @checkbox="checkbox"
          @showPrivew="showPrivew(file)"
          @crop="crop"
          @loadFiles="loadFiles"
          :permissions="permissions"
          :showHeader="showHeader"
          :attachment_type_name="attachment_type_name"
        />
      </b-col>
      <CropFile
        ref="cropComponet"
        :file="myfile"
        :mode="`priview`"
        :aspectRatio="aspectRatio"
        :initialAspectRatio="initialAspectRatio"
        @save="saveCrop"
      />
    </b-row>
    <b-modal
      size="xl"
      id="modal-priview"
      header-tag="header"
      v-model="priviewModal"
      hide-footer
      class="modal-priview"
    >
      <template v-slot:modal-header>
        <div class="float-left">
          <span @click="toggleModal">
            <i class="fas fa-times hover-fa-times fa-lg" />
          </span>
        </div>
        <div class="float-right" v-b-tooltip.hover :title="$lang.details">
          <button
            v-if="showFilePreview"
            type="button"
            name=""
            id=""
            class="btn btn-lightgray"
            @click="showDetails = !showDetails"
          >
            <span v-if="showDetails" key="fa-chevron-lef">
              <i class="fa fa-chevron-left" aria-hidden="true"></i
            ></span>
            <span v-else key="fa-chevron-right"
              ><i class="fa fa-chevron-right" aria-hidden="true"></i
            ></span>
          </button>
        </div>
      </template>
      <FilePreviewPage
        ref="filePriviewPage"
        :permissions="permissions"
        :files="files"
        :showDetails="showDetails && showFilePreview"
        :indexPriview="indexPriview"
        @removeFile="removeFile"
        @selectedChange="selectedChange"
      />
    </b-modal>
  </div>
</template>
<script>
import File from "./file";
import FilePreviewPage from "./filePriview/filePriviewPage";
import CropFile from "./cropFile";
import { pathOr } from "ramda";
import { getAttachmentOriginal } from "@/services";
import { toastAlert } from "@/shared/utils";

export default {
  name: "file-list",
  inject: ["attachmentFilesRepository"],
  components: {
    File,
    FilePreviewPage,
    CropFile,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    classFile: {
      type: String,
      default: "col-12 col-sm-6 col-md-4 col-xl-3",
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: [Function, Array],
      default: () => [],
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showFilePreview: {
      type: Boolean,
      default: true,
    },
    keyService: {
      type: String,
      default: null,
    },
    keyValue: {
      type: [String, Number],
      default: null,
    },
    hasEditTypeAttachment: {
      type: Boolean,
      default: false,
    },
    attachment_type_name: {
      type: String,
      default: "attachment_type_person",
    },
  },
  data() {
    return {
      over: {}, // برای درک فایل‌ها
      priviewModal: false, // نمایش مدال جزئیات
      startLoc: 0, // برای درک فایل‌ها
      dragging: false, // برای درک فایل‌ها
      dragFrom: {}, // برای درک فایل‌ها
      indexPriview: 0, // برای درک فایل‌ها
      myfile: {},
      code: this.$route.params.code,
      showDetails: false,
      aspectRatio: 1 / 1,
      initialAspectRatio: 1 / 1,
    };
  },
  methods: {
    pathOr,
    toggleModal() {
      this.priviewModal = false;
      this.$emit("getFiles");
    },
    crop(file) {
      this.myfile = file;

      /* guidance: check if type upload was profile image set 3/4 aspect ratio for cropping */
      const attachmentTypeId = pathOr(null, ["attachment_type", "id"], file);
      const con = attachmentTypeId === 10;
      this.aspectRatio = con ? 1 / 1 : null;
      this.initialAspectRatio = con ? 1 / 1 : null;

      this.$refs.cropComponet.view_crop = true;
    },
    saveCrop(image) {
      this.$emit("saveCrop", image);
    },
    /**
     * @vuese
     * 	چک کردن نوع فایل
     *  @arg  یارامتر ارسالی ابجکت فایل به نام file
     */
    showPrivew(file) {
      this.priviewModal = !this.priviewModal;
      let index = this.files.indexOf(file);
      this.indexPriview = index;
    },
    /**
     * @vuese
     * 	برای درک فایل هی
     *  @arg  پارامتر فایل و اتفاقاات در فانکسن
     */
    startDrag(item, e) {
      this.startLoc = e.clientY;
      this.dragging = true;
      this.dragFrom = item;
    },
    /**
     * @vuese
     * 	برای درک فایل هی
     *  @arg   پارامتر فایل ومکان فایل
     */
    finishDrag(item, pos) {
      this.files.splice(pos, 1);
      this.files.splice(this.over.pos, 0, item);
      this.over = {};
    },
    /**
     * @vuese
     * 	برای درک فایل هی
     *  @arg   پارامتر فایل و اتفاقاات در فانکسنو مکان فایل
     */
    onDragOver(item, pos, e) {
      const dir = this.startLoc < e.clientY ? "down" : "up";
      setTimeout(() => {
        this.over = {
          item,
          pos,
          dir,
        };
      }, 50);
    },
    /**
     * @vuese
     * 	چک کردن نوع فایل
     *  @arg   یارامتر ارسالی ابجکت فایل به نام ایدی
     */
    removeFile(item) {
      if (
        this.$refs.filePriviewPage != null &&
        this.$refs.filePriviewPage.active == -1
      )
        this.priviewModal = false;
      this.$emit("removeFile", item);
    },
    /**
     * @vuese
     * 	برای ست کردن عکس دیفالت
     *  @arg  یارامتر ارسالی ابجکت فایل به نام ایدی
     */
    checkbox(id) {
      this.$emit("checkbox", id);
    },
    async selectedChange(selected_attachment, file) {
      try {
        let payload = {
          confirm_type_id: selected_attachment
            ? selected_attachment.value
            : null,
        };
        const response = await this.attachmentFilesRepository.partial_edit(
          "person",
          this.code,
          file.id,
          payload
        );
        this.priviewModal = false;
        this.$emit("getFiles");
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    loadFiles() {
      this.$emit("loadFiles");
    },
  },
};
</script>
<style lang="scss">
.list > div {
  display: flex;
  flex-direction: column;
}

.item {
  display: inline-block;
}

.flip-list-move {
  transition: transform 0.2s;
}

.over {
  opacity: 0.6;
}

#modal-priview___BV_modal_body_ {
  padding: 0;
}

@media (max-width: 980px) {
  #modal-priview > .modal-lg,
  .modal-xl {
    max-width: 100% !important;
  }
}

.hover-fa-times {
  cursor: pointer;

  &:hover {
    color: red;
  }
}
</style>
